import rems from './utils/rems';

const spacingBase = 12;
const spacingBasePlusHalf = 18;
const spacing2x = spacingBase * 2;
const spacing3x = spacingBase * 3;
const spacingHalf = spacingBase / 2;
const spacingThird = spacingBase / 3;

const verticalRhythms = {
  verticalRhythmBase: `${spacingBase * 2}px`, // 24px
  verticalRhythm2x: `${spacingBase * 4}px`, // 48px
  verticalRhythm3x: `${spacingBase * 6}px`, // 72px
  verticalRhythmHalf: `${spacingBase}px`, // 12px
};

const margins = {
  marginBase: `${spacingBase}px`, // 12px
  marginBasePlusHalf: `${spacingBasePlusHalf}px`, // 18px
  margin2x: `${spacing2x}px`, // 24px
  marginHalf: `${spacingHalf}px`, // 6px
  marginThird: `${spacingThird}px`, // 4px
};

const paddings = {
  paddingBase: `${spacingBase}px`, // 12px
  paddingBasePlusHalf: `${spacingBasePlusHalf}px`, // 18px
  padding2x: `${spacing2x}px`, // 24px
  padding3x: `${spacing3x}px`, //36px
  paddingHalf: `${spacingHalf}px`, // 6px
  paddingThird: `${spacingThird}px`, // 4px
};

const dimensions = {
  headerHeight: '94px',
  headerHeightMobile: '66px',
};

export default {
  // Don't use these ones going forward
  ...verticalRhythms,
  ...margins,
  ...paddings,

  // Use these ones!
  spacingXs: rems(4),
  spacingSm: rems(8),
  spacingMd: rems(16),
  spacingLg: rems(24),
  spacingXl: rems(32),
  spacingXxl: rems(48),

  ...dimensions,
};
